export const state = {
  bandeiraCartao: {
    nome: "",
    codigo: "",
  },
  bandeirasCartao: [],
  modalExcluirBandeiraCartao: false,
  modalCadastrarBandeiraCartao: false,
};

export default {};
